import { render, staticRenderFns } from "./I18NDetailList.vue?vue&type=template&id=b1c1b87e&scoped=true&"
import script from "./I18NDetailList.vue?vue&type=script&lang=js&"
export * from "./I18NDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c1b87e",
  null
  
)

export default component.exports